'use strict';

export default {
  setLang(state, lang) {
    state.lang = lang;
  },
  setOemCompany(state, oemCompany) {
    state.oemCompany = oemCompany;
  },
  setSession(state, session){
    state.session = session;
  },
  setEmailModel(state,model){
    state.emailModel = model
  },
  setScreenSize(state,size){
    state.screenSize=size;
  },
  setMobile(state,mobile){
    state.mobile=mobile;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js